export const dateFormatter = (params) => {
  if (!params.value) return '';
  return new Date(params.value).toLocaleString("tr-TR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};